import React from 'react';
import './EntryDescription.less';

export const EntryDescription = ({text, isExpanded}) => {
	return <div className={`entry-description ${isExpanded ? 'entry-description--expanded' : ''}`}
							dangerouslySetInnerHTML={{__html: text}}
	></div>;
};
